import axios from 'axios'
import urls from '@/config/urls'

const baseURL = urls.apiUrl
const baseMockURL = 'http://localhost:3000/'

const http = axios.create({
    baseURL: baseURL,
    withCredentials: true,
    timeout: 600000
})

const httpMock = axios.create({
    baseURL: baseMockURL,
    withCredentials: true,
    timeout: 10000
})

export {http, httpMock}